import { render } from "./BlankPage.vue?vue&type=template&id=08eb03d6&scoped=true"
import script from "./BlankPage.vue?vue&type=script&lang=js"
export * from "./BlankPage.vue?vue&type=script&lang=js"

import "./BlankPage.vue?vue&type=style&index=0&id=08eb03d6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08eb03d6"]])

export default __exports__